<template>
    <div>
        Brak konsultacji
    </div>
</template>

<script>
    export default {
        name: "MyConsultations"
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/MyConsultations.vue